"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MainTabsContext = new _react.default.createContext({
  tabs: [],
  setTabs: function setTabs(tabs) {}
});
var _default = MainTabsContext;
exports.default = _default;